import BusinessFundingProgramDetail from './BusinessFundingProgramDetail';

export default BusinessFundingProgramDetail;
